import React from 'react';

const PartnerTableActionsCell = ({ onView, onDelete, viewLabel = 'View' }) => (
  <td className="partner-table-actions-cell">
    <div className="partner-table-actions">
      <button type="button" className="partner-view-btn" onClick={onView}>
        {viewLabel}
      </button>
      {onDelete ? (
        <button type="button" className="partner-delete-btn" onClick={onDelete}>
          Delete
        </button>
      ) : null}
    </div>
  </td>
);

export default PartnerTableActionsCell;
